import React from 'react';
import styled from 'styled-components';
import Particles from 'react-particles-js';
import Layout from '../components/layout';

import Header from '../components/Header';
import Main from '../components/Main';

const StyledParticles = styled(Particles)`
  canvas {
    background-color: transparent;
    position: absolute;
    height: 100%;
    width: 100%;
  }
`;

const ParticlesContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 2;
`;

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isArticleVisible: false,
      timeout: false,
      articleTimeout: false,
      article: '',
      loading: 'is-loading',
    };
    this.handleOpenArticle = this.handleOpenArticle.bind(this);
    this.handleCloseArticle = this.handleCloseArticle.bind(this);
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ loading: '' });
    }, 100);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  handleOpenArticle(article) {
    const { isArticleVisible } = this.state;
    this.setState({
      isArticleVisible: !isArticleVisible,
      article,
    });

    setTimeout(() => {
      const { timeout } = this.state;
      this.setState({
        timeout: !timeout,
      });
    }, 325);

    setTimeout(() => {
      const { articleTimeout } = this.state;
      this.setState({
        articleTimeout: !articleTimeout,
      });
    }, 350);
  }

  handleCloseArticle() {
    const { articleTimeout } = this.state;
    this.setState({
      articleTimeout: !articleTimeout,
    });

    setTimeout(() => {
      const { timeout } = this.state;
      this.setState({
        timeout: !timeout,
      });
    }, 325);

    setTimeout(() => {
      const { isArticleVisible } = this.state;
      this.setState({
        isArticleVisible: !isArticleVisible,
        article: '',
      });
    }, 350);
  }

  render() {
    const { location } = this.props;
    const {
      loading,
      isArticleVisible,
      timeout,
      articleTimeout,
      article,
    } = this.state;
    return (
      <Layout location={location}>
        <ParticlesContainer
          className={`body ${loading} ${
            isArticleVisible ? 'is-article-visible' : ''
          }`}
        >
          <StyledParticles
            params={{
              fps_limit: 29,
              particles: {
                number: {
                  value: 200,
                  density: {
                    enable: false,
                  },
                },
                line_linked: {
                  enable: true,
                  distance: 180,
                  opacity: 0.25,
                },
                move: {
                  speed: 1.5,
                },
                opacity: {
                  anim: {
                    enable: true,
                    opacity_min: 0.05,
                    speed: 2,
                    sync: false,
                  },
                  value: 0.4,
                },
              },
              polygon: {
                enable: true,
                scale: 1,
                type: 'inline',
                move: {
                  radius: 10,
                },
                url: 'src/images/biotech.svg',
                inline: {
                  arrangement: 'equidistant',
                },
                draw: {
                  enable: true,
                },
              },
              retina_detect: false,
              interactivity: {
                events: {
                  onhover: {
                    enable: true,
                    mode: 'repulse',
                  },
                },
                modes: {
                  repulse: {
                    size: 6,
                    distance: 40,
                  },
                },
              },
            }}
          />
        </ParticlesContainer>
        <div id="wrapper">
          <Header onOpenArticle={this.handleOpenArticle} timeout={timeout} />
          <Main
            isArticleVisible={isArticleVisible}
            timeout={timeout}
            articleTimeout={articleTimeout}
            article={article}
            onCloseArticle={this.handleCloseArticle}
          />
        </div>
      </Layout>
    );
  }
}

export default IndexPage;
